<div class="allcont logsize">
  <div class="basicrow ">
    <div class="center-iptv">
      <div class="general-iptv">
        <div class="iptv-box" *ngIf="this.createIptv==true">
          <div class="btitle">
            <div class="iptv-img">
              <img src="/assets/images/reg-a-icon.png">
            </div>
            Crea tu cuenta <a class="ClaroTv">Claro</a><a class="tvmas">tv+</a>
          </div>
          <div class="iptv-text">
            Ingresa tu correo electrónico. Lo usarás para iniciar sesión en todos tus dispositivos.
          </div>
          <div>
            <div class="conteiner-email-create-iptv">
              <div class="iptv-text black-text">
                User ID
              </div>
              <div>
                <form [formGroup]="signupForm">
                  <div class="basicrow ">
                    <div class="form-box">
                      <input class="promocodeinp " required formControlName="email" type="text" id="email"
                        placeholder="Correo Electrónico">
                      <div class="promoapplybtn" (click)="this.validador();">
                        <div class="btntxt din-b">
                          VALIDAR
                          <img width="100%" class="btnicon" src="../../assets/images/btnicon02.png">
                        </div>
                      </div>
                      <div [hidden]="signupForm.controls.email.value || signupForm.controls.email.untouched"
                        class="alert2 alert-danger tabforminp-def-iiii">
                        Email Requerido
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="basicrow " *ngIf="this.createIptv==false">
          <div class="overallpadded-c roboto-r padding">
            <div class="basicrow f-big-ii m-top txt-center f-red ">
              <div class="validtitle-def">
                Validación realizada con <span class="roboto-b"> éxito</span>
                <img class="clarotitlebars" width="100%" src="../../assets/images/ico_claro.png">
              </div>
            </div>
            <div class="basicrow txt-center">
              <div class="btn-continue" (click)="this.continue();">
                <div class="btntxt din-b">
                  CONTINUAR
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
